import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { EmbateDto } from '@models/embate/clash-dto';
import { FormBase } from '@models/portal/users/form-base';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { Observable, finalize } from 'rxjs';
import { BaseService } from '../base-service';
import { IPage } from '@models/pagination/page';
import { ResponseDto } from '@models/exceptions/response-dto';

@Injectable({
  providedIn: 'root'
})
export class EspacoVagaService extends BaseService {
  private readonly url = `${environment.apiUrl}/v1/espacos-vagas`;

  criar(form: EspacoVagaForm): Observable<EspacoVagaDto> {
    this.loadingService.activate();

    return this.http
      .post<ResponseDto<EspacoVagaDto>>(`${this.url}`, form)
      .pipe(
        extractResponse(),
        finalize(() => this.loadingService.deactivate()),
      );
  }

  editar(form: EspacoVagaForm): Observable<EspacoVagaDto> {
    this.loadingService.activate();

    return this.http
      .put<ResponseDto<EspacoVagaDto>>(`${this.url}`, form)
      .pipe(
        extractResponse(),
        finalize(() => this.loadingService.deactivate()),
      );
  }

  buscarPorId(entNrId: number): Observable<EspacoVagaDto> {
    this.loadingService.activate();

    return this.http
      .get<ResponseDto<EspacoVagaDto>>(`${this.url}/${entNrId}`)
      .pipe(
        extractResponse(),
        finalize(() => this.loadingService.deactivate()),
      );
  }

  deletar(entNrId: number): Observable<void> {
    this.loadingService.activate();

    return this.http
      .delete<void>(`${this.url}/${entNrId}`)
      .pipe(
        finalize(() => this.loadingService.deactivate()),
      );
  }

  removerEmbateDaVaga(epvNrId: number): Observable<void> {
    this.loadingService.activate();

    return this.http
      .delete<void>(`${this.url}/remover-embate/${epvNrId}`)
      .pipe(finalize(() => this.loadingService.deactivate()));
  }

  buscarVagasDoEspacoRodada(
    eprNrId: number,
    page = 0,
    size = 10,
  ): Observable<IPage<EspacoVagaDto>> {
    this.loadingService.activate();

    return this.http
      .get<ResponseDto<IPage<EspacoVagaDto>>>(
        `${this.url}/espaco-rodada/${eprNrId}?page=${page}&size=${size}`,
      )
      .pipe(
        extractResponse(),
        finalize(() => this.loadingService.deactivate()),
      );
  }
}

export interface EspacoVagaDto {
  epvNrId: number;
  embateDto?: EmbateDto;
  eprNrId: number;
  epvNrOrdemVaga?: number;
  epvDtVaga?: string;
  epvTmInicio: string;
  epvTmFim?: string;
}

export interface EspacoVagaForm extends FormBase {
  eprNrId?: number;
  epvNrOrdemVaga?: number;
  epvDtVaga?: string;
  epvTmInicio?: string;
  epvTmFim?: string;
  epvBlValidaIntervalo?: boolean;
}
